export default __webpack_public_path__ + "static/media/bg-tbm-online.f4057bce.jpeg";